import cn from "../../../../utils/cn"

const HeaderCell = ({ className, children }) => (
  <th
    className={cn(
      "border border-gray-300 px-2 py-2 text-left text-gray-700 text-[14px]",
      className
    )}
  >
    {children}
  </th>
)

export default HeaderCell
